module.exports = __webpack_public_path__ + "static/media/darkLight.33c258ad.png";